import React, {useState, useEffect, useRef} from 'react'
import parse from 'html-react-parser';
import { Link } from 'react-router-dom';

const ListDisplay = ({type, data}) => {

    function workDisplay(){
        const styles ={
            list: {},
            item: {
                marginBottom: 20
            },
            title:{
                color: '#666',
                marginBottom: 5,
                fontSize: 20,
                fontWeight: 500
            },
            subtTitle:{
                color: '#666',
                marginBottom: 5,
                fontSize: 16,
                fontWeight: 500
            },
            value:{
                color: '#666',
                marginBottom: 3,
                fontSize: 14
            },
        }

        return (
            <div style={styles.list}>
                {data.map(itm => (
                    <div style={styles.item}>{workItem(itm, styles)}</div>
                ))}
            </div>
        )
    }

    function workItem(obj, styles){

        let end = "";
        if(obj.Ongoing){
            end = "Ongoing"
        }else{
            end = (obj.End !="")? `${obj.End.month} ${obj.End.year}`: "";
        }

        return (
            <div>
                <h4>
                    <span style={styles.title}>{obj.Employer}</span>
                    <span style={styles.subtTitle}> ({obj.JobTitle})</span>
                </h4>
                <div style={styles.value}>{obj.JobLevel} | {obj.JobType}</div>
                <div style={styles.value}>{obj.JobMode} | {obj.Location}</div>
                <div style={styles.value}>{obj.Start.month} {obj.Start.year} - {end}</div>
                <div style={styles.value}>{parse(obj.Description)}</div>
            </div>
        )
    }
    
    function eduDisplay(){
        const styles ={
            list: {},
            item: {
                marginBottom: 20
            },
            title:{
                color: '#666',
                marginBottom: 5,
                fontSize: 20,
                fontWeight: 500
            },
            subtTitle:{
                color: '#666',
                marginBottom: 5,
                fontSize: 16,
                fontWeight: 500
            },
            value:{
                color: '#666',
                marginBottom: 3,
                fontSize: 14
            },
        }

        return (
            <div style={styles.list}>
                {data.map(itm => (
                    <div style={styles.item}>{eduItem(itm, styles)}</div>
                ))}
            </div>
        )
    }

    function eduItem(obj, styles){

        let end = "";
        if(obj.Ongoing){
            end = "Ongoing"
        }else{
            end = (obj.End !="")? `${obj.End.month} ${obj.End.year}`: "";
        }

        return (
            <div>
                <h4>
                    <span style={styles.title}>{obj.Institution}</span>
                    <span style={styles.subtTitle}> ({obj.Qualification})</span>
                </h4>
                <div style={styles.value}>{obj.Description}</div>
                <div style={styles.value}>{obj.Start.month} {obj.Start.year} - {end}</div>
            </div>
        )
    }

    function skillDisplay(){
        const styles ={
            list: {
                display: 'flex'
            },
            item: {
                background: '#f8f5fe',
                color: '#717886',
                marginTop: 5,
                marginRight: 10,
                marginBottom: 5,
                padding: '2px 10px',
                borderRadius: 3,
                fontSize: 15,
            }
        }

        return (
            <div style={styles.list}>
                {data.map(itm => (
                    <div style={styles.item}>{itm.Name}</div>
                ))}
            </div>
        )
    }

    function projDisplay(){
        const styles ={
            list: {},
            item: {
                marginBottom: 20
            },
            title:{
                color: '#666',
                marginBottom: 5,
                fontSize: 18,
                fontWeight: 500
            },
            desc:{
                color: '#666',
                marginBottom: 5,
                fontSize: 14
            },
            btn:{
                fontSize: 14,
                textDecoration: 'none'
            },
        }

        return (
            <div style={styles.list}>
                {data.map(itm => (
                    <div style={styles.item}>{projItem(itm, styles)}</div>
                ))}
            </div>
        )
    }

    function projItem(obj, styles){
        return (
            <div>
                <h4 style={styles.title}>{obj.Title}</h4>
                <div style={styles.desc}>{obj.Description}</div>
                <Link to={obj.Link} style={styles.btn}>Preview</Link>
            </div>
        )
    }

    return (
        <div>
            {(type=="works") && workDisplay()}
            {(type=="educations") && eduDisplay()}
            {(type=="skills") && skillDisplay()}
            {(type=="projects") && projDisplay()}
        </div>
    )
}

export default ListDisplay